import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LGEDataService } from 'src/commons';

@Component({
    selector: 'confirm-modal',
    templateUrl: '././confirm.component.html',
    styleUrls: ['././confirm.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmModalComponent implements OnInit, OnDestroy {
    @Input() title: string;
    @Input() message: string;

    constructor(
        private dialogRef: MatDialogRef<ConfirmModalComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private _dataService: LGEDataService,
        private ref: ChangeDetectorRef,
    ) {
        this.title = data.title;
        this.message = data.message;
    }

    ngOnInit() {

    }

    onYes (data: any) {
        this.dialogRef.close(data);
    }

    onNo(data: any) {
        this.dialogRef.close(data);
    }

    ngOnDestroy() {

    }

} 

